import { ReactNode } from 'react';

/**
 * Renders bold text with optional color styling based on a specific format.
 * 
 * If the input text is a string and matches the format `{text:color}`, it extracts
 * the `text` and applies the `color` as a hex color code to the `<strong>` tag.
 * 
 * @param text - The text to render, which can be a ReactNode.
 * @returns A string representing the HTML for the bold text.
 */
export const renderBoldText = (text: ReactNode): string => {
  const regex = /^\{[^:]*:[^}]*\}$/;
  let color;

  if (typeof text === 'string') {
    const checkReg = regex.test(text);
    if (checkReg) {
      const originalText = text.split(':')[0].replace('{', '');
      color = '#' + text.split(':')[1].replace('}', '');
      text = originalText;
    }
  }

  return color
    ? `<strong style="color: ${color}">${text}</strong>`
    : `<strong>${text}</strong>`;
};
